<template>
  <div style="height:calc(100vh - 140px);">
    <Breadcrumb :levelList="levelList"/>
    <div class="aibfb entity_labelBox">
      <div class="entity_labelLeft pull-left">
        <div class="entity_sysSearchOne aimt5 pull-left" style="width:100%;">
          <el-input placeholder="检索关键字" class="selectInput pull-right" v-model="entity_labelLeftSearch" size="small">
            <svg slot="suffix" class="icon" aria-hidden="true" @click="search()">
              <use xlink:href="#iconsearchicon" />
            </svg>
          </el-input>
        </div>
          <div class="tree_box">
              <div class="tree-plus-add" @click="addTree()"><i class="el-icon-plus"></i></div>
              <el-tree
                      ref="tree_tree"
                      :data="treeData"
                      node-key="id"
                      @node-click="handleNodeClick"
                      default-expand-all
                      :expand-on-click-node="false">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                    <span>
                        <span class="tree_button tree_button_edit" @click="editTree(data)"><i class="el-icon-edit-outline"></i></span>
                        <span class="tree_button tree_button_delete"><i class="el-icon-delete" @click="deleteTree(data)"></i></span>
                    </span>
                  </span>
              </el-tree>
          </div>
      </div>
      <div class="entity_labelRight pull-right pst">
        <div class="aibfb aimt5 pull-left">
          <el-button class="pull-right" type="primary" size="small" @click="goOff()">返 回</el-button>
          <el-select class="pull-left aimr10 entity_w130" size="small" v-model="entity_labelSelect" placeholder="所有状态" clearable>
            <el-option label="已标注" :value="1"></el-option>
            <el-option label="未标注" :value="0"></el-option>
          </el-select>
          <div class="entity_sysSearchOne aimr10 pull-left">
            <el-input placeholder="添加关键字" class="selectInput pull-right" v-model="entity_labelRightearch" size="small">
              <svg slot="suffix" class="icon" aria-hidden="true" @click="searchLabel(treeIndex)">
                <use xlink:href="#iconsearchicon" />
              </svg>
            </el-input>
          </div>
        </div>
        <div class="aibfb pull-left tagTable aimt10">
          <el-table ref="corpusTableData" :data="labelTableData" style="width:100%" @selection-change="changeFun">
            <el-table-column type="selection" width="55" :show-overflow-tooltip="false"></el-table-column>
            <el-table-column align="center" label="标签名称" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="pull-left aimr10 tag_Name" align="left" @click="editTagButton(scope.row)">{{ scope.row.name }}</div>
                <div class="pull-left entity_tableLabelColor" :style="{ background: scope.row.colorSelection }"></div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dimension" label="标注状态" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.markState == 0" style="color:#666666">未标注</span>
                <span v-if="scope.row.markState == 1" style="color:#337eff">已标注</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="entity_sysfooter" style="width: calc(100% - 180px);left:200px;">
        <el-button class="pull-left" type="info" size="small" icon="el-icon-plus" @click="addTagButton()">新增</el-button>
        <el-button class="pull-left" size="small" @click="deleteTagButton()">删除</el-button>
      </div>
    </div>
    <el-drawer class="entity_drawerBox" size="450px" title="" :visible.sync="drawerAddLabel">
      <div class="aibfb pull-left entity_drawerBtnHeader">
        <el-button class="pull-left" type="primary" size="small" @click="versionSave()">保 存</el-button>
      </div>
      <div class="aibfb pull-left entity_drawerLabelBox">
        <el-form size="small" ref="entity_drawerLabelForm" :model="entity_drawerLabelForm" :rules="rulesData" label-width="80px">
          <el-form-item label="名称" prop="name">
            <el-input v-model="entity_drawerLabelForm.name"></el-input>
          </el-form-item>
          <el-form-item label="备注(可选)">
              <el-input v-model="entity_drawerLabelForm.remark" style="margin-top: 10px"></el-input>
          </el-form-item>
          <el-form-item label="颜色选择" prop="color">
              <el-color-picker v-model="entity_drawerLabelForm.color"></el-color-picker>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import { getCategoryList, addCategory, updateCategory, addTag, updateTag, deleteCategory, deleteTag } from '../../../../../api/entity/entity'
export default {
  name: 'index',
  components: { Breadcrumb },
  data() {
    return {
      levelList: [{ path: '@/views/entity/custom/tag/label', title: '实体标注' }],
      // ========= new
      treeData: [],
      labelTableData: [],
      entity_labelSelect: '',
      entity_labelLeftSearch: '',
      entity_labelRightearch: '',
      treeIndex: undefined,
      entity_drawerLabelForm: {
        type: '',
        name: '',
        remark: '',
        color: '',
        isSave: '',
        id: ''
      },
      drawerAddLabel: false,
      rulesData: {
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        color: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      selectTable: []
    }
  },
  methods: {
    goOff: function () {
      this.$emit('toIndex', 'list', {})
    },
    search() {
      const that = this
      this.treeData = []
      this.treeIndex = undefined
      getCategoryList().then(response => {
        if (response.data.code === 2000) {
          let data = response.data.data
          if (data && data.length > 0) {
            const treeList = []
            if (this.entity_labelLeftSearch !== '') {
              data = data.filter(function (item) {
                return item.name.indexOf(that.entity_labelLeftSearch) !== -1
              })
            }
            data.forEach(function (item) {
              treeList.push({
                id: item.id,
                label: item.name,
                data: item
              })
            })
            this.treeData = [...treeList]
            this.$nextTick(() => {
              this.searchLabel(this.treeData.length > 0 ? this.treeData[0].data : null)
            })
            // 找第一个选中的
          }
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        console.error(error)
      })
    },
    searchLabel(itemData) {
      this.labelTableData = []
      this.selectTable = []
      const that = this
      if (!itemData) {
        this.treeIndex = undefined
        return
      } else {
        this.treeIndex = { ...itemData }
      }
      this.$refs.tree_tree.setCurrentKey(itemData.id)
      let tagList = [...itemData.tagList]
      if (tagList && tagList.length > 0) {
        if (this.entity_labelRightearch !== '') {
          tagList = tagList.filter(function (item) {
            return item.name.indexOf(that.entity_labelRightearch) !== -1
          })
        }
        if (this.entity_labelSelect !== '') {
          tagList = tagList.filter(function (item) {
            return item.markState === that.entity_labelSelect
          })
        }
        tagList.forEach(function (item) {
          that.labelTableData.push({
            ...item
          })
        })
      }
    },
    searchLabelforDb(itemData) {
      this.labelTableData = []
      this.selectTable = []
      const that = this
      if (!itemData) {
        this.treeIndex = undefined
        return
      } else {
        this.treeIndex = { ...itemData }
      }
      getCategoryList().then(response => {
        if (response.data.code === 2000) {
          let data = response.data.data
          if (data && data.length > 0) {
            const treeList = []
            if (this.entity_labelLeftSearch !== '') {
              data = data.filter(function (item) {
                return item.name.indexOf(that.entity_labelLeftSearch) !== -1
              })
            }
            data.forEach(function (item) {
              treeList.push({
                id: item.id,
                label: item.name,
                data: item
              })
            })
            this.treeData = [...treeList]
            this.$nextTick(() => {
              that.$refs.tree_tree.setCurrentKey(itemData.id)
            })
            const treeNode = data.find(function (item) {
              return item.id === itemData.id
            })
            if (treeNode) {
              let tagList = [...treeNode.tagList]
              if (tagList && tagList.length > 0) {
                if (this.entity_labelRightearch !== '') {
                  tagList = tagList.filter(function (item) {
                    return item.name.indexOf(that.entity_labelRightearch) !== -1
                  })
                }
                if (this.entity_labelSelect !== '') {
                  tagList = tagList.filter(function (item) {
                    return item.markState === that.entity_labelSelect
                  })
                }
                tagList.forEach(function (item) {
                  that.labelTableData.push({
                    ...item
                  })
                })
              }
            }
          }
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        console.error(error)
      })
    },
    handleNodeClick(data, node, e) {
      this.searchLabel(data.data)
    },
    addTree() {
      this.entity_drawerLabelForm.type = 'tree'
      this.entity_drawerLabelForm.color = ''
      this.entity_drawerLabelForm.isSave = true
      this.entity_drawerLabelForm.name = ''
      this.entity_drawerLabelForm.remark = ''
      this.drawerAddLabel = true
    },
    editTree(item) {
      this.entity_drawerLabelForm.id = item.data.id
      this.entity_drawerLabelForm.type = 'tree'
      this.entity_drawerLabelForm.color = item.data.colorSelection
      this.entity_drawerLabelForm.isSave = false
      this.entity_drawerLabelForm.name = item.data.name
      this.entity_drawerLabelForm.remark = item.data.remark
      this.drawerAddLabel = true
    },
    addTagButton() {
      if (!this.treeIndex) {
        return
      }
      this.entity_drawerLabelForm.type = 'tag'
      this.entity_drawerLabelForm.color = ''
      this.entity_drawerLabelForm.isSave = true
      this.entity_drawerLabelForm.name = ''
      this.entity_drawerLabelForm.remark = ''
      this.drawerAddLabel = true
    },
    editTagButton(item) {
      if (!this.treeIndex) {
        return
      }
      this.entity_drawerLabelForm.id = item.id
      this.entity_drawerLabelForm.type = 'tag'
      this.entity_drawerLabelForm.color = item.colorSelection
      this.entity_drawerLabelForm.isSave = false
      this.entity_drawerLabelForm.name = item.name
      this.entity_drawerLabelForm.remark = item.remark
      this.drawerAddLabel = true
    },
    versionSave() {
      const that = this
      this.$refs.entity_drawerLabelForm.validate((valid) => {
        if (valid) {
          if (that.entity_drawerLabelForm.type === 'tree' && that.entity_drawerLabelForm.isSave) {
            that.addTreeData()
          }
          if (that.entity_drawerLabelForm.type === 'tree' && !that.entity_drawerLabelForm.isSave) {
            that.editTreeData()
          }
          if (that.entity_drawerLabelForm.type === 'tag' && that.entity_drawerLabelForm.isSave) {
            that.addTagData()
          }
          if (that.entity_drawerLabelForm.type === 'tag' && !that.entity_drawerLabelForm.isSave) {
            that.editTagData()
          }
        } else {
          return false
        }
      })
    },
    addTreeData() {
      const that = this
      const params = {
        name: that.entity_drawerLabelForm.name,
        remark: that.entity_drawerLabelForm.remark,
        colorSelection: that.entity_drawerLabelForm.color
      }
      addCategory(params).then(response => {
        if (response.data.code === 2000) {
          this.drawerAddLabel = false
          that.search()
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    editTreeData() {
      const that = this
      const params = {
        id: that.entity_drawerLabelForm.id,
        name: that.entity_drawerLabelForm.name,
        remark: that.entity_drawerLabelForm.remark,
        colorSelection: that.entity_drawerLabelForm.color
      }
      updateCategory(params).then(response => {
        if (response.data.code === 2000) {
          this.drawerAddLabel = false
          that.search()
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    addTagData() {
      const that = this
      const indexData = JSON.parse(JSON.stringify(that.treeIndex))
      const params = {
        categoryId: that.treeIndex.id,
        name: that.entity_drawerLabelForm.name,
        remark: that.entity_drawerLabelForm.remark,
        colorSelection: that.entity_drawerLabelForm.color
      }
      addTag(params).then(response => {
        if (response.data.code === 2000) {
          this.drawerAddLabel = false
          this.searchLabelforDb(indexData)
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    editTagData() {
      const that = this
      const indexData = JSON.parse(JSON.stringify(that.treeIndex))
      const params = {
        categoryId: that.treeIndex.id,
        name: that.entity_drawerLabelForm.name,
        remark: that.entity_drawerLabelForm.remark,
        colorSelection: that.entity_drawerLabelForm.color,
        id: that.entity_drawerLabelForm.id
      }
      updateTag(params).then(response => {
        if (response.data.code === 2000) {
          this.drawerAddLabel = false
          this.searchLabelforDb(indexData)
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    deleteTree(item) {
      const that = this
      window.entityMessageBox({
        title: '提示',
        text: '此操作将永久删除, 是否继续?',
        f: function() {
          that.deleteTreeData({ id: item.id })
        },
        c: function() {
        }
      })
    },
    deleteTreeData(params) {
      deleteCategory(params).then(response => {
        if (response.data.code === 2000) {
          this.search()
          window.entityMessage({ type: 'success', text: '删除成功' })
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    changeFun(val) {
      const that = this
      this.selectTable = []
      if (val) {
        val.forEach(function (item) {
          that.selectTable.push(item.id)
        })
      }
    },
    deleteTagButton() {
      if (!this.selectTable || this.selectTable.length === 0) {
        return
      }
      const that = this
      window.entityMessageBox({
        title: '提示',
        text: '此操作将永久删除, 是否继续?',
        f: function() {
          that.deleteTagData()
        },
        c: function() {
        }
      })
    },
    deleteTagData() {
      deleteTag(this.selectTable).then(response => {
        if (response.data.code === 2000) {
          const indexData = JSON.parse(JSON.stringify(this.treeIndex))
          this.searchLabelforDb(indexData)
          window.entityMessage({ type: 'success', text: '删除成功' })
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    }
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped>
    .tree_box {
        width: 100%;
        height: calc(100% - 40px);
        margin-top: 40px
    }
    .tree_button_edit {
        padding: 0 3px;
        position: absolute;
        right: 20px;
    }
    .tree_button_delete {
        padding: 0 3px;
        position: absolute;
        right: 0px;
    }
    .tree_button {
        font-size: 12px;
    }
    .tree_button:hover {
        color: #337eff;
    }
    .tree-plus-add {
        width: 100%;
        height: 20px;
        line-height: 20px;
        border: #e1e3e6 solid 1px;
        text-align: center;
        color: #e1e3e6;
        margin-bottom: 5px;
        cursor: pointer;
        border-radius: 4px;
    }
    .tree-plus-add:hover {
        color: #bbb;
        border: #bbb solid 1px;
    }
    .tag_Name {
        text-decoration:underline;
        cursor: pointer;
    }
    .tag_Name:hover {
        color: #337eff;
    }
</style>
<style>
    .selectInput.el-input .el-input__suffix{
        top:1px!important;
    }
</style>
